import React from 'react';

const NotificationsPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default NotificationsPage;
